import React from 'react';
import { ReactComponent as ConstructionIcon } from '../../assets/icons/construction-gray.svg';
import { Box, IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

interface TwRejectedTripProps {
  fromOverlay?: boolean;
  onClose?: () => void;
}

export const TwRejectedTrip: React.FC<TwRejectedTripProps> = ({
  fromOverlay = false,
  onClose
}): JSX.Element => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '12px',
        height: fromOverlay ? '90vh' : '80vh',
        width: '100%'
      }}
    >
      {fromOverlay && (
        <IconButton onClick={onClose} size="small" sx={{ position: 'absolute', top: '11px', right: '22px' }}>
          <CloseIcon />
        </IconButton>
      )}
      <ConstructionIcon width={100} height={130} />
      <Typography
        variant="h6"
        sx={{
          fontWeight: 600,
          fontSize: {
            xs: fromOverlay ? '16px' : '18px',
            sm: fromOverlay ? '18px' : '20px',
            md: fromOverlay ? '22px' : '24px'
          }
        }}
      >
        This trip has been declined
      </Typography>
      <Typography
        variant="body2"
        sx={{
          textAlign: 'center',
          color: '#6B7280',
          fontSize: {
            xs: fromOverlay ? '12px' : '14px',
            sm: fromOverlay ? '14px' : '16px',
            md: fromOverlay ? '16px' : '18px'
          }
        }}
      >
        You have chosen to decline this trip. Please contact your dispatcher if this was a mistake.
      </Typography>
    </Box>
  );
};
